import React, { useEffect, useState } from 'react';
import { TextField, Grid, Typography, Box } from '@mui/material';
import useManageOrder from '../../order/useManageOrder';
import { calculateOrdersSummary, generateSummaryText } from '../../../utils/orderUtils';
import { formatAmount, formatAmountRound } from '../../../utils/formatAmount';
import { useSelector } from 'react-redux';

const womenList = ['Eve', 'Meen', 'Phat', 'Kluay'];

const BlacklistOrders = ({ profile, user }) => {
  const { getBlacklistItems } = useManageOrder();
  const [ordersSummary, setOrdersSummary] = useState({});
  const [finalText, setFinalText] = useState('');
  const [selectedOrdersText, setSelectedOrdersText] = useState('');
  const [gender, setGender] = useState('ครับ');
  const shopName = useSelector((state) => state.shop.name);

  useEffect(() => {
    const fetchBlacklistItems = async () => {
      try {
        const response = await getBlacklistItems(profile.id);
        console.log(response);

        const selectedOrdersSummary = calculateOrdersSummary(response.selectedOrders);

        setOrdersSummary({
          selectedOrders: selectedOrdersSummary.summary,
        });
        setFinalText(`ขออนุญาตสรุปยอดที่ยังค้างชำระค่าสินค้าทั้งหมดให้นะครับ
        \nรายการค้างชำระทั้งหมด ${response.notPaidTotalCount} รายการ รวมเป็นยอด ${formatAmountRound(response.notPaidTotalAmount)} บาทครับ
(หากต้องการทราบรายการทั้งหมดสามารถแจ้ง admin กลับได้เลยครับ)
        \nหรือหากคุณลูกค้ายังไม่สะดวกชำระเป็นยอดดังกล่าว สามารถชำระเป็นยอดขั้นต่ำที่ตามนี้ได้เลยครับ\n
${generateSummaryText(selectedOrdersSummary.summary, selectedOrdersSummary.grandTotal, gender, shopName === 'tama' , true).replace('ขออนุญาตสรุปยอดให้นะครับ',"").replace('ขออนุญาตสรุปยอดให้นะคะ',"").trim()}
        \nขอบคุณมากครับ
        `)

      } catch (error) {
        console.error('Error fetching blacklist items:', error);
      }
    };

    if (profile) {
      fetchBlacklistItems();
    }
  }, [profile]);

  useEffect(() => {
    if (womenList.includes(user.nickname)) {
      setGender('คะ');
    }
  }, [user]);


  return (
    <Box padding={4}>
      <h2 className='text-4xl'>รายการค้างจ่าย</h2>
      <Grid container spacing={2}>
        {/* Upper section */}
        <Grid item xs={6}>
          <TextField
            label="Contact"
            value={profile.contact}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            label="Smile Name"
            value={profile.smileName}
            fullWidth
            variant="outlined"
          />
        </Grid>

        {/* Lower section */}
        <Grid item xs={12}>
          <Box mt={4}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography variant="h6">ยอดค้าง 30%</Typography>
                <TextField
                  multiline
                  rows={18}
                  variant="outlined"
                  fullWidth
                  value={finalText}
                />
              </Grid>
             
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BlacklistOrders;
